export default "__VITE_ASSET__0978326e__"